export const TEXT_ONLY_LAYOUT = 'text_only';
export const LOGO_ONLY_LAYOUT = 'logo_only';
export const TEXT_AND_LOGO_LAYOUT = 'text_and_logo';
export const BENTO_IMAGES_HOST = 'https://images.getbento.com';
